/**
 * 预定义的宽高比选项
 */
const PREDEFINED_RATIOS = [1 / 1, 3 / 4, 4 / 3, 16 / 9]

/**
 * 获取最接近的预定义比例
 */
export function getClosestRatio(naturalRatio: number): number {
  return PREDEFINED_RATIOS.reduce((prev, curr) => {
    return Math.abs(curr - naturalRatio) < Math.abs(prev - naturalRatio)
      ? curr
      : prev
  })
}
